import type { IconSvgObject } from './types';

const ShieldKeyIcon: IconSvgObject = [
  ["path", { d: "M20.9999 5C18.8786 3.17002 15.635 2 11.9999 2C8.36488 2 5.12131 3.17002 2.99994 5V11C2.99994 19 11.9999 22 11.9999 22C11.9999 22 20.9999 19 20.9999 11L20.9999 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9999 11C13.1045 11 13.9999 10.1046 13.9999 9C13.9999 7.89543 13.1045 7 11.9999 7C10.8954 7 9.99994 7.89543 9.99994 9C9.99994 10.1046 10.8954 11 11.9999 11ZM11.9999 11V13.5M13.9999 16H11.9999V13.5M11.9999 13.5H13.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ShieldKeyIcon;
